module.exports = __webpack_public_path__ + "static/media/footer3.56c19fb4.png";